export const FOOTER = [
    {
        id: 1,
        name: 'Documentos',
        items: [
            {
                id: 1,
                name: 'Información legal',
                url: 'https://kaizenwp.com/files/Informacion_Legal_Kaizen_Wealth_Planning_2025.pdf'
            },
            {
                id: 2,
                name: '¿Cómo operamos?',
                url: 'https://kaizenwp.com/files/C%C3%B3mo_Operamos_Kaizen%20Wealth%20Planning_2025.pdf'
            },
            {
                id: 3,
                name: 'Términos y condiciones',
                url: 'https://kaizenwp.com/files/Terminos_y_Condiciones_KaizenWP_2025.pdf'
            },
            {
                id: 4,
                name: 'Política de privacidad y cookies',
                url: 'https://kaizenwp.com/files/Politica_Privacidad_y_Cookies_KaizenWP_2025.pdf'
            }
        ]
    },
    {
        id: 2,
        name: 'Mapa de Sitio',
        items: [
            {
                id: 1,
                name: '¿Por qué Kaizen?',
                url: '/motivo'
            },
            {
                id: 2,
                name: 'Soluciones Kaizen Wealth Planning',
                url: '/soluciones'
            },
            {
                id: 3,
                name: 'Metodología',
                url: '/metodologia'
            },
            {
                id: 4,
                name: 'Plataforma asesores',
                url: 'https://backoffice.capitalkaizen.com/'
            }
        ]
    },
    {
        id: 3,
        name: 'Contáctanos',
        items: [
            {
                id: 1,
                name: 'conversemos@kaizen.com.pe',
                url: ''
            },
            {
                id: 2,
                name: 'Deseo conversar por WhatsApp',
                url: ''
            },
            {
                id: 3,
                name: 'Deseo conversar por llamada',
                url: ''
            }
        ]
    }
];